import { ListItem, StyledComponentProps, Divider } from '@material-ui/core';
import * as React from 'react';
import { trainer } from '../../../../model/trainer';
import { TrainerInfo } from './TrainerInfo';

interface IContactItemProps extends StyledComponentProps {
    trainer: trainer;
    onTrainerClick: (_id: string) => void;
    isSelected: boolean;
}
interface IContactItemState {
    open: boolean;
    openRoom: boolean;
}

export class TrainerItem extends React.Component<IContactItemProps, IContactItemState> {
    state = { open: false, openRoom: false }

    render() {
        const { trainer, classes } = this.props;
        return (
            <>
                <ListItem button
                    onClick={() => this.props.onTrainerClick(this.props.trainer._id)}
                    className={this.props.isSelected ? classes.selectedTrainer : classes.trainer}
                    >
                    <TrainerInfo trainer={trainer} classes={classes} />
                </ListItem>
                <Divider />
            </>
        );
    }
}